// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
// import { mapGetters } from 'vuex'

Vue.config.productionTip = false

/* eslint-disable */

// Vue.component('bar-chart', {
// 	extends: VueChartJs.Bar,
// 	data: function () {
// 		return {
// 			datacollection: {
// 				labels: ['#감동적인', '#흥미로운', '#안타까움', '#답답함', '#기타'],
// 				datasets: [
// 					{
// 						label: '',
// 						backgroundColor: 'black',
// 						pointBackgroundColor: 'black',
// 						borderWidth: 1,
// 						pointBorderColor: 'black',
// 						data: this.$store.getters.session_hashtag
// 					}]
// 			},
// 			options: {
// 				scales: {
// 					yAxes: [{
// 						ticks: {
// 							beginAtZero: true
// 						},
// 						gridLines: {
// 							display: false
// 						}
// 					}],
// 					xAxes: [{
// 						ticks: {
// 							beginAtZero: true
// 						},
// 						gridLines: {
// 							display: false
// 						}
// 					}]
// 				},
// 				legend: {
// 					display: false
// 				},
// 				tooltips: {
// 					enabled: false,
// 					mode: 'single',
// 					callbacks: {
// 						label: function(tooltipItems, data) {
// 							return '$' + tooltipItems.yLabel;
// 						}
// 					}
// 				},
// 				responsive: true,
// 				maintainAspectRatio: true,
// 				height: 50
// }
// 		}
// 	},
// 	computed :{
// 		...mapGetters([
// 			'current_article_id',
// 			'session_hashtag'
// 		])
// 	},
// 	mounted () {
// 		// this.chartData is created in the mixin
// 		this.$store.dispatch('loadhashtag', this.current_article_id )
// 		this.renderChart(this.datacollection, this.options)
// 	}
// })

const vm =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js